import React, { useState, useEffect } from 'react';
import { Trash2 } from 'lucide-react';
import { adminStatsService } from '../../../services/adminStatsService';
import { useSeasonContext } from '../../../context/SeasonContext';

const TransactionItemBlock = ({ block, onUpdate, onDelete }) => {
  const [players, setPlayers] = useState([]);
  const { selectedSeason } = useSeasonContext();

  useEffect(() => {
    if (selectedSeason?.id) {
      fetchPlayers();
    }
  }, [selectedSeason?.id]);

  const fetchPlayers = async () => {
    try {
      const playerList = await adminStatsService.getPlayersForSeason(selectedSeason.id);
      setPlayers(playerList);
    } catch (error) {
      console.error('Error fetching players:', error);
    }
  };

  const handlePlayerChange = (playerName) => {
    const selectedPlayer = players.find(p => p.name === playerName);
    onUpdate(block.id, {
      player: playerName,
      team: selectedPlayer?.team || ''
    });
  };

  return (
    <div className="block-item transaction-block">
      <div className="block-header">
        <span>Transaction</span>
        <button
          type="button"
          className="btn-icon-small delete"
          onClick={() => onDelete(block.id)}
        >
          <Trash2 size={16} />
        </button>
      </div>
      <select
        value={block.type || 'signing'}
        onChange={(e) => onUpdate(block.id, { type: e.target.value })}
        className="field-select"
      >
        <option value="signing">Signing</option>
        <option value="trade">Trade</option>
        <option value="release">Release</option>
        <option value="injury">Injury Report</option>
        <option value="contract">Contract Extension</option>
      </select>
      <select
        value={block.player || ''}
        onChange={(e) => handlePlayerChange(e.target.value)}
        className="field-select"
      >
        <option value="">Select player</option>
        {players.map((player) => (
          <option key={player.name} value={player.name}>
            {player.name}
          </option>
        ))}
      </select>
      <input
        type="text"
        placeholder="Team"
        value={block.team || ''}
        disabled
        className="field-input"
      />
      <input
        type="date"
        value={block.date || ''}
        onChange={(e) => onUpdate(block.id, { date: e.target.value })}
        className="field-input"
      />
    </div>
  );
};

export default TransactionItemBlock;
